import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withKeys as _withKeys, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withCtx as _withCtx, normalizeClass as _normalizeClass, Transition as _Transition, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { id: "skill-experience-title" }
const _hoisted_2 = {
  key: 0,
  class: "skill-experience-dialog__error",
  role: "alert"
}
const _hoisted_3 = { class: "skill-experience-dialog__actions" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["aria-modal", "aria-hidden", "inert"]
const _hoisted_7 = { class: "job-header" }
const _hoisted_8 = { class: "job-header__main" }
const _hoisted_9 = {
  class: "company-mark",
  "aria-hidden": "true"
}
const _hoisted_10 = { class: "job-header__copy" }
const _hoisted_11 = { class: "job-company" }
const _hoisted_12 = { id: "job-detail-title" }
const _hoisted_13 = {
  key: 0,
  class: "job-posted"
}
const _hoisted_14 = { class: "job-header__actions" }
const _hoisted_15 = {
  key: 0,
  class: "match-score"
}
const _hoisted_16 = {
  key: 0,
  class: "job-facts",
  "aria-label": "Job summary"
}
const _hoisted_17 = {
  id: "application-step-panel",
  class: "status-form"
}
const _hoisted_18 = { class: "status-form__fields" }
const _hoisted_19 = { class: "status-form__status" }
const _hoisted_20 = ["value"]
const _hoisted_21 = ["value"]
const _hoisted_22 = {
  key: 1,
  class: "custom-time"
}
const _hoisted_23 = { class: "status-form__note" }
const _hoisted_24 = { class: "status-form__actions" }
const _hoisted_25 = ["disabled"]
const _hoisted_26 = { class: "job-workspace" }
const _hoisted_27 = {
  key: 0,
  class: "skills-lane"
}
const _hoisted_28 = { class: "lane-heading skills-lane__heading" }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { class: "skill-list" }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = {
  key: 1,
  class: "skill-required"
}
const _hoisted_33 = { class: "job-description-panel" }
const _hoisted_34 = { class: "section-heading job-description-heading" }
const _hoisted_35 = ["href"]
const _hoisted_36 = ["innerHTML"]
const _hoisted_37 = ["aria-expanded"]
const _hoisted_38 = {
  key: 0,
  id: "job-notes-panel",
  class: "notes-lane"
}
const _hoisted_39 = { class: "lane-heading" }
const _hoisted_40 = {
  key: 0,
  class: "notes-preview"
}
const _hoisted_41 = { key: 1 }
const _hoisted_42 = { class: "job-footer" }
const _hoisted_43 = { class: "job-footer__actions" }
const _hoisted_44 = ["aria-expanded"]
const _hoisted_45 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_ApplicationJourney = _resolveComponent("ApplicationJourney")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    ($setup.selectionAction)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "selection-add-button",
          type: "button",
          style: _normalizeStyle({ top: `${$setup.selectionAction.top}px`, left: `${$setup.selectionAction.left}px` }),
          onMousedown: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => ($setup.openSkillExperienceDialog && $setup.openSkillExperienceDialog(...args)), ["prevent"])),
          onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(($event: any) => ($setup.selectionAction = null), ["prevent"]), ["esc"]))
        }, [
          _createVNode(_component_font_awesome_icon, { icon: "plus" }),
          _cache[25] || (_cache[25] = _createTextVNode(" Add skill "))
        ], 36))
      : _createCommentVNode("", true),
    ($setup.isSkillExperienceDialogOpen)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "skill-experience-backdrop",
          onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => ($setup.closeSkillExperienceDialog && $setup.closeSkillExperienceDialog(...args)), ["self"]))
        }, [
          _createElementVNode("form", {
            ref: "skillDialogRef",
            class: "skill-experience-dialog",
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": "skill-experience-title",
            tabindex: "-1",
            onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => ($setup.handleAddSelectedSkill && $setup.handleAddSelectedSkill(...args)), ["prevent"])),
            onKeydown: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => ($setup.handleSkillDialogKeydown && $setup.handleSkillDialogKeydown(...args)))
          }, [
            _createElementVNode("div", null, [
              _cache[26] || (_cache[26] = _createElementVNode("p", { class: "skill-experience-dialog__eyebrow" }, "Add to your skills", -1)),
              _createElementVNode("h2", _hoisted_1, _toDisplayString($setup.selectedSkillText), 1)
            ]),
            _createElementVNode("label", null, [
              _cache[27] || (_cache[27] = _createElementVNode("span", null, "Years of experience", -1)),
              _withDirectives(_createElementVNode("input", {
                ref: "skillYearsInputRef",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.selectedSkillYears) = $event)),
                type: "number",
                min: "0",
                max: "50",
                step: "1",
                inputmode: "numeric",
                autofocus: "",
                placeholder: "0"
              }, null, 512), [
                [_vModelText, $setup.selectedSkillYears]
              ])
            ]),
            ($setup.skillExperienceError)
              ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString($setup.skillExperienceError), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("button", {
                class: "secondary-button",
                type: "button",
                disabled: $setup.isAddingSelectedSkill,
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.closeSkillExperienceDialog && $setup.closeSkillExperienceDialog(...args)))
              }, " Cancel ", 8, _hoisted_4),
              _createElementVNode("button", {
                class: "primary-button",
                type: "submit",
                disabled: $setup.isAddingSelectedSkill
              }, _toDisplayString($setup.isAddingSelectedSkill ? 'Adding...' : 'Add skill'), 9, _hoisted_5)
            ])
          ], 544)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_Transition, { name: "modal" }, {
      default: _withCtx(() => [
        ($props.isOpen)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "job-modal-backdrop",
              onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => ($setup.closeModal && $setup.closeModal(...args)))
            }, [
              _createElementVNode("article", {
                ref: "jobModalRef",
                class: _normalizeClass(['job-modal', { 'job-modal--expanded': $setup.isDescriptionExpanded }]),
                role: "dialog",
                "aria-modal": $setup.isSkillExperienceDialogOpen ? undefined : 'true',
                "aria-hidden": $setup.isSkillExperienceDialogOpen ? 'true' : undefined,
                inert: $setup.isSkillExperienceDialogOpen || undefined,
                "aria-labelledby": "job-detail-title",
                tabindex: "-1",
                onClick: _cache[22] || (_cache[22] = _withModifiers(() => {}, ["stop"])),
                onKeydown: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => ($setup.handleJobModalKeydown && $setup.handleJobModalKeydown(...args)))
              }, [
                _createElementVNode("header", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, _toDisplayString($setup.companyInitials), 1),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("p", _hoisted_11, _toDisplayString($props.job?.company), 1),
                      _createElementVNode("h1", _hoisted_12, _toDisplayString($props.job?.title), 1),
                      ($props.job?.date_posted)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_13, "Posted " + _toDisplayString($setup.formatDate($props.job.date_posted)), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    ($setup.matchPercentage !== null)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          _createElementVNode("span", null, _toDisplayString($setup.matchPercentage) + "%", 1),
                          _cache[28] || (_cache[28] = _createElementVNode("small", null, "skill match", -1))
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      ref: "mainCloseButtonRef",
                      class: "icon-button",
                      type: "button",
                      "aria-label": "Close job details",
                      onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => ($setup.closeModal && $setup.closeModal(...args)))
                    }, [
                      _createVNode(_component_font_awesome_icon, { icon: "times" })
                    ], 512)
                  ])
                ]),
                ($setup.jobFacts.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.jobFacts, (fact) => {
                        return (_openBlock(), _createElementBlock("span", {
                          key: fact.key,
                          class: "job-fact"
                        }, [
                          _createVNode(_component_font_awesome_icon, {
                            icon: fact.icon,
                            class: "job-fact__icon"
                          }, null, 8, ["icon"]),
                          _createTextVNode(" " + _toDisplayString(fact.value), 1)
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_ApplicationJourney, {
                  steps: $setup.localProcessSteps,
                  "current-status": $setup.currentStatus,
                  "found-date": $props.job?.date_posted || $props.job?.application_date || $props.job?.latest_status_date || '',
                  expanded: $setup.isApplicationPanelOpen,
                  toggleable: $setup.canAddStep,
                  onToggle: _cache[15] || (_cache[15] = ($event: any) => ($setup.isApplicationPanelOpen = !$setup.isApplicationPanelOpen))
                }, {
                  form: _withCtx(() => [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("label", _hoisted_19, [
                          _cache[30] || (_cache[30] = _createElementVNode("span", null, "Next step", -1)),
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.selectedStatus) = $event))
                          }, [
                            _cache[29] || (_cache[29] = _createElementVNode("option", { value: "" }, "Select next step", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.statuses, (status) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: status,
                                value: status
                              }, _toDisplayString(status), 9, _hoisted_20))
                            }), 128))
                          ], 512), [
                            [_vModelSelect, $setup.selectedStatus]
                          ])
                        ]),
                        _createElementVNode("label", null, [
                          _cache[31] || (_cache[31] = _createElementVNode("span", null, "Date", -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.statusDate) = $event)),
                            type: "date"
                          }, null, 512), [
                            [_vModelText, $setup.statusDate]
                          ])
                        ]),
                        _createElementVNode("label", null, [
                          _cache[34] || (_cache[34] = _createElementVNode("span", null, "Time", -1)),
                          (!$setup.isCustomTime)
                            ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                key: 0,
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.selectedTimeSlot) = $event))
                              }, [
                                _cache[32] || (_cache[32] = _createElementVNode("option", { value: "" }, "Not set", -1)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.timeSlots, (slot) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: slot.value,
                                    value: slot.value
                                  }, _toDisplayString(slot.label), 9, _hoisted_21))
                                }), 128)),
                                _cache[33] || (_cache[33] = _createElementVNode("option", { value: "custom" }, "Custom", -1))
                              ], 512)), [
                                [_vModelSelect, $setup.selectedTimeSlot]
                              ])
                            : (_openBlock(), _createElementBlock("span", _hoisted_22, [
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.customTime) = $event)),
                                  type: "time"
                                }, null, 512), [
                                  [_vModelText, $setup.customTime]
                                ]),
                                _createElementVNode("button", {
                                  type: "button",
                                  onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => ($setup.useTimeSlots && $setup.useTimeSlots(...args)))
                                }, "Reset")
                              ]))
                        ]),
                        _createElementVNode("label", _hoisted_23, [
                          _cache[35] || (_cache[35] = _createElementVNode("span", null, [
                            _createTextVNode("Note "),
                            _createElementVNode("small", null, "Optional")
                          ], -1)),
                          _withDirectives(_createElementVNode("textarea", {
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($setup.statusNotes) = $event)),
                            rows: "1",
                            placeholder: "Add context for this step"
                          }, null, 512), [
                            [_vModelText, $setup.statusNotes]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("button", {
                          class: "primary-button status-form__save",
                          type: "button",
                          disabled: !$setup.selectedStatus || $setup.isSavingStatus,
                          onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => ($setup.handleUpdateStatus && $setup.handleUpdateStatus(...args)))
                        }, [
                          _createVNode(_component_font_awesome_icon, { icon: "check" }),
                          _createTextVNode(" " + _toDisplayString($setup.isSavingStatus ? 'Saving...' : 'Save update'), 1)
                        ], 8, _hoisted_25)
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["steps", "current-status", "found-date", "expanded", "toggleable"]),
                _createElementVNode("div", _hoisted_26, [
                  ($setup.normalizedSkills.length)
                    ? (_openBlock(), _createElementBlock("section", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, [
                          _createElementVNode("div", null, [
                            _cache[36] || (_cache[36] = _createElementVNode("h2", null, "Skills", -1)),
                            ($setup.normalizedSkills.length)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_29, _toDisplayString($setup.matchedSkillCount) + " of " + _toDisplayString($setup.normalizedSkills.length) + " matched ", 1))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("ul", _hoisted_30, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.normalizedSkills, (skill) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: skill.skill_name,
                              class: _normalizeClass({ 'skill-item--matched': skill.user_has })
                            }, [
                              _createVNode(_component_font_awesome_icon, {
                                icon: skill.user_has ? 'check' : 'circle'
                              }, null, 8, ["icon"]),
                              _createElementVNode("span", null, _toDisplayString(skill.skill_name), 1),
                              (skill.years_required)
                                ? (_openBlock(), _createElementBlock("small", _hoisted_31, _toDisplayString(skill.years_required) + "y", 1))
                                : _createCommentVNode("", true),
                              (skill.is_required)
                                ? (_openBlock(), _createElementBlock("small", _hoisted_32, "Required"))
                                : _createCommentVNode("", true)
                            ], 2))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("main", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                      _cache[38] || (_cache[38] = _createElementVNode("h2", null, "Job description", -1)),
                      _createElementVNode("p", {
                        class: _normalizeClass(["description-skill-helper", { 'description-skill-helper--error': $setup.skillSelectionFeedbackType === 'error' }]),
                        role: "status"
                      }, [
                        _createVNode(_component_font_awesome_icon, {
                          icon: $setup.skillSelectionFeedbackType === 'error' ? 'times' : $setup.skillSelectionFeedback ? 'check' : 'plus'
                        }, null, 8, ["icon"]),
                        _createTextVNode(" " + _toDisplayString($setup.skillSelectionFeedback || 'Select a skill in the job description to add it to your skills.'), 1)
                      ], 2),
                      ($props.job?.job_url)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            href: $props.job.job_url,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            class: "text-link"
                          }, [
                            _cache[37] || (_cache[37] = _createTextVNode(" View original ")),
                            _createVNode(_component_font_awesome_icon, { icon: "external-link" })
                          ], 8, _hoisted_35))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", {
                      ref: "descriptionViewportRef",
                      class: _normalizeClass(["job-description-viewport", { 'job-description-viewport--expanded': $setup.isDescriptionExpanded }])
                    }, [
                      _createElementVNode("div", {
                        ref: "descriptionContentRef",
                        innerHTML: $setup.sanitizedDescription,
                        class: "job-description",
                        tabindex: "-1",
                        onMouseup: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => ($setup.handleDescriptionSelection && $setup.handleDescriptionSelection(...args)))
                      }, null, 40, _hoisted_36)
                    ], 2),
                    ($setup.isDescriptionOverflowing || $setup.isDescriptionExpanded)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          class: "show-description-button",
                          "aria-expanded": $setup.isDescriptionExpanded,
                          onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => ($setup.toggleDescription && $setup.toggleDescription(...args)))
                        }, [
                          _createTextVNode(_toDisplayString($setup.isDescriptionExpanded ? 'Show less' : 'Show more') + " ", 1),
                          _createVNode(_component_font_awesome_icon, {
                            icon: "chevron-down",
                            class: _normalizeClass({ 'show-description-button__icon--open': $setup.isDescriptionExpanded })
                          }, null, 8, ["class"])
                        ], 8, _hoisted_37))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(_Transition, { name: "accordion" }, {
                    default: _withCtx(() => [
                      ($setup.isTrackedJob && $setup.isNotesOpen)
                        ? (_openBlock(), _createElementBlock("section", _hoisted_38, [
                            _createElementVNode("div", _hoisted_39, [
                              _createElementVNode("div", null, [
                                _cache[39] || (_cache[39] = _createElementVNode("h2", null, "Notes", -1)),
                                (!$setup.isEditingGeneralNotes)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_40, _toDisplayString($setup.generalNotes || 'No notes yet.'), 1))
                                  : (_openBlock(), _createElementBlock("p", _hoisted_41, "Private application notes"))
                              ]),
                              _createElementVNode("button", {
                                class: "secondary-button secondary-button--small",
                                type: "button",
                                onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => ($setup.toggleGeneralNotesEdit && $setup.toggleGeneralNotesEdit(...args)))
                              }, _toDisplayString($setup.isEditingGeneralNotes ? 'Save' : 'Edit'), 1)
                            ]),
                            ($setup.isEditingGeneralNotes)
                              ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                                  key: 0,
                                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (($setup.generalNotes) = $event)),
                                  rows: "5",
                                  placeholder: "Add notes about this application"
                                }, null, 512)), [
                                  [_vModelText, $setup.generalNotes]
                                ])
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("footer", _hoisted_42, [
                  _createElementVNode("div", _hoisted_43, [
                    ($setup.isTrackedJob)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "footer-link",
                          type: "button",
                          "aria-expanded": $setup.isNotesOpen,
                          "aria-controls": "job-notes-panel",
                          onClick: _cache[20] || (_cache[20] = ($event: any) => ($setup.isNotesOpen = !$setup.isNotesOpen))
                        }, [
                          _cache[40] || (_cache[40] = _createTextVNode(" Notes ")),
                          _createVNode(_component_font_awesome_icon, {
                            icon: "chevron-down",
                            class: _normalizeClass({ 'footer-link__icon--open': $setup.isNotesOpen })
                          }, null, 8, ["class"])
                        ], 8, _hoisted_44))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      class: "secondary-button",
                      type: "button",
                      onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => ($setup.closeModal && $setup.closeModal(...args)))
                    }, "Close"),
                    ($setup.canApply)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 1,
                          href: $props.job.job_url,
                          target: "_blank",
                          rel: "noopener noreferrer",
                          class: "primary-button"
                        }, [
                          _cache[41] || (_cache[41] = _createTextVNode(" Apply ")),
                          _createVNode(_component_font_awesome_icon, { icon: "arrow-right" })
                        ], 8, _hoisted_45))
                      : _createCommentVNode("", true)
                  ])
                ])
              ], 42, _hoisted_6)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}